export default __webpack_public_path__ + "static/banner-christmas-156f1f81924b4c988453cbde25120230.jpg";